/* unplugin-vue-components disabled */import script from "./info.vue?vue&type=script&setup=true&lang=ts"
export * from "./info.vue?vue&type=script&setup=true&lang=ts"

import "./info.vue?vue&type=style&index=0&id=14613ffa&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\17532\\Desktop\\school\\logistics-meet\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14613ffa"]])

export default __exports__